import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTypography = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginRight: '8px'
});

export default StyledTypography;
